import { FC, ReactNode } from "react";
import { Link } from "react-router-dom";
import { useThemedOnboardingImage } from "~/hooks/useThemedOnboardingImage";
import { AppLogo } from "../AppLogo";
import { LanguageSelector } from "../LanguageSelector";

interface SplitLayoutProps {
  children: ReactNode;
  imageSrc?: string;
  imageAlt?: string;
}

export const SplitLayout: FC<SplitLayoutProps> = ({
  children,
  imageSrc,
  imageAlt = "Background",
}) => {
  const bgImage = useThemedOnboardingImage("background");

  return (
    <div className="flex min-h-screen">
      <div className={`w-full ${imageSrc ? "lg:w-1/2" : ""} flex flex-col`}>
        <div className="p-4 sm:p-6 flex items-center border-b justify-between border-border">
          <Link to="/" className="inline-block w-[82px]">
            <AppLogo />
          </Link>
          <LanguageSelector variant="compact" />
        </div>

        <div className="flex-1 flex justify-center px-4 sm:px-6 lg:px-0">
          <div className="w-full max-w-[560px] pt-6 sm:pt-10 lg:pt-[80px]">
            {children}
          </div>
        </div>
      </div>

      {imageSrc && (
        <div className="hidden lg:flex lg:w-1/2 items-center justify-center relative">
          <img
            src={bgImage}
            className="absolute inset-0 w-full h-full object-cover"
          />
          <img
            src={imageSrc}
            alt={imageAlt}
            className="max-w-[500px] absolute z-10 m-auto left-0 right-0 top-1/2 transform -translate-y-1/2"
          />
        </div>
      )}
    </div>
  );
};
